import { shrpaApi } from "@/repos/axios";
import type { CustomerSocialMediaSettingsData, SocialMediaSettingsV2Response, UpdateSocialSettingsV2Request } from "@/contracts/socialMediaSettings";
import { getCalendarId } from "@logic/calendarManager";

const basePath = "/social-media-settings";

export default class SocialMediaSettingsRepo {
  static async getSettings(customerId: string): Promise<SocialMediaSettingsV2Response> {
    const calendarId = await getCalendarId(customerId);
    const response = await shrpaApi.get(`${basePath}/${encodeURIComponent(customerId)}/${encodeURIComponent(calendarId)}/v2`);
    return response.data as SocialMediaSettingsV2Response;
  }

  static async updateSettings(settings: CustomerSocialMediaSettingsData, timeZone: string | null): Promise<SocialMediaSettingsV2Response> {
    if (!settings?.id || !settings?.customerId) throw new Error("settings.id and settings.customerId are required");
    const calendarId = await getCalendarId(settings.customerId);
    const url = `${basePath}/${encodeURIComponent(settings.customerId)}/${encodeURIComponent(calendarId)}/${encodeURIComponent(settings.id)}/v2`;
    const payload: UpdateSocialSettingsV2Request = { settings, timeZone };
    const response = await shrpaApi.put(url, payload);
    return response.data as SocialMediaSettingsV2Response;
  }

  static async checkForLinkedAccount(customerId: string): Promise<CustomerSocialMediaSettingsData> {
    const calendarId = await getCalendarId(customerId);
    const url = `${basePath}/${encodeURIComponent(customerId)}/${encodeURIComponent(calendarId)}/check-for-linked-account`;
    const response = await shrpaApi.put(url);
    return response.data as CustomerSocialMediaSettingsData;
  }
}
